import {createSearchParams, useParams, useSearchParams} from 'react-router-dom';
import getSurveyPath from 'ui/utils/getSurveyPath';

const filterParamsList = ['akey'];

export const useFormUrl = () => {
    const {surveyId = ''} = useParams();
    const [searchParams] = useSearchParams();

    let result = getSurveyPath({surveyId, withBase: true});
    searchParams.set('page', '1');
    filterParamsList.forEach((param) => {
        searchParams.delete(param);
    });
    result += `?${createSearchParams(searchParams)}`;

    return result;
};
